'use strict';

class AccountDeactivate {
  constructor($window, originatorService, Notification) {
    this.$window = $window;
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.codes = [{
      value: 'TOO_EXPENSIVE',
      label: 'Tjenesten er for dyr'
    }, {
      value: 'OTHER',
      label: 'Annet'
    }, {
      value: 'BAD_SUPPORT',
      label: 'Dårlig kundestøtte'
    }, {
      value: 'DIFFERENT_SYSTEM',
      label: 'Nytt regnskapssystem (hvilket produkt?)'
    }];
    this.data = {
      reason: null,
      code: 'OTHER',
      password: null
    };
  }

  send() {
    this.originatorService.validateDeactivate()
      .then(() => {
        this.originatorService.deactivate(this.data)
          .then(() => {
            this.$window.sessionStorage.removeItem('originatorId');
            this.$window.location.href = '/';
          });
      });
  }
}

AccountDeactivate.$inject = ['$window', 'originatorService', 'Notification'];

const accountDeactivate = {
  controller: AccountDeactivate,
  template: `
    <h2>Deaktiver konto</h2>

    <fieldset>
      <div>
        <label for="code">Foreta ett valg</label>
        <select ng-model="$ctrl.data.code" ng-options="code.value as code.label for code in $ctrl.codes" id="code" required></select>
      </div>
      <div>
        <label for="reason">Hvorfor deaktiverer du din konto hos oss?</label>
        <textarea name="reason" id="reason" ng-model="$ctrl.data.reason"></textarea>
      </div>
    </fieldset>

    <fieldset>
      <label for="password">Passord</label>
      <input type="password" name="password" id="password" ng-model="$ctrl.data.password" required>
    </fieldset>

    <a role="button" class="button secondary" href="#/konto">Avbryt</a>
    <button ng-click="$ctrl.send()" class="button alert">Deaktiver</button>
  `
};

angular
  .module('SendRegning')
  .component('accountDeactivate', accountDeactivate)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/deaktiver', {
        title: 'Deaktiver konto',
        template: '<account-deactivate />',
        secure: true
      });
  });
